import { ReactNode } from 'react'
import { Button, ButtonProps } from 'antd'

type IProps = {
  customText?: ReactNode
} & ButtonProps

const CancelButton = ({ customText, ...props }: IProps) => (
  <Button {...props}>{customText ?? 'Hủy'}</Button>
)

export default CancelButton
